import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ConfirmDialogData } from './dialog.data';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false,
})
export class DialogComponent implements OnInit, OnDestroy {
  @Input() data: ConfirmDialogData | undefined;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<string>();

  private dialogRef: HTMLElement | null = null;

  ngOnInit() {
    document.addEventListener('click', this.onDocumentClick);
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  private onDocumentClick = (event: MouseEvent) => {
    if (this.dialogRef && !this.dialogRef.contains(event.target as Node)) {
      this.onCancel();
    }
  };

  onConfirm(value: string) {
    this.confirm.emit(value);
  }

  onCancel() {
    this.closeDialog.emit();
  }

  setDialogRef(dialogRef: HTMLElement) {
    this.dialogRef = dialogRef;
  }
}
